<template>
   <div
        :class="{
            'option': true,
            'option-active': option.selected,
            'option-margin': isWidescreen && !['h5', 'rich'].includes(mode)
        }"
        @click="handleOptionClick"
        @mouseover="handleMouseOver"
        @mouseout="handleMouseOut">
        <div
            class="voiceAvatar"
            :style="{
                'background-image': `url(${option.icon_url})`,
                'background-size': 'contain',
                'background-repeat': 'no-repeat',
                'background-position': 'center'
            }">
            <div
                :class="{
                    'residentOverlay': ([VoiceStatus.Loading, VoiceStatus.Ready, VoiceStatus.Playing].includes(audioSourceStatus)) && isCurrentOptionPlay ? true : false,
                    'overlay': true
                }"
                @click="handlePlay"
            >
                <svg v-if="[VoiceStatus.Unready, VoiceStatus.Ready].includes(audioSourceStatus)" t="1729845842151" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11039" width="200" height="200"><path d="M817.088 484.96l-512-323.744C295.232 154.976 282.752 154.592 272.576 160.224 262.336 165.856 256 176.608 256 188.256l0 647.328c0 11.648 6.336 22.4 16.576 28.032 4.8 2.656 10.112 3.968 15.424 3.968 5.952 0 11.904-1.664 17.088-4.928l512-323.616C826.368 533.184 832 522.976 832 512 832 501.024 826.368 490.816 817.088 484.96z" fill="#ffffff" p-id="11040"/></svg>
                <svg v-else-if="[VoiceStatus.Playing].includes(audioSourceStatus)" t="1729845620929" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9151" width="200" height="200"><path d="M384 256a42.666667 42.666667 0 0 0-42.666667-42.666667H298.666667a42.666667 42.666667 0 0 0-42.666667 42.666667v554.666667a42.666667 42.666667 0 0 0 42.666667 42.666666h42.666666a42.666667 42.666667 0 0 0 42.666667-42.666666V256z m384 0a42.666667 42.666667 0 0 0-42.666667-42.666667h-42.666666a42.666667 42.666667 0 0 0-42.666667 42.666667v554.666667a42.666667 42.666667 0 0 0 42.666667 42.666666h42.666666a42.666667 42.666667 0 0 0 42.666667-42.666666V256z" fill="#ffffff" p-id="9152" /></svg>
                <i
                    v-else-if="[VoiceStatus.Loading].includes(audioSourceStatus)"
                    style="color: #FFFFFF"
                    class="el-icon-loading"
                />
            </div>
        </div>
        <span
            :class="{
                'text': true,
                'textContent': true,
                'textActive': option.selected
            }"
        >{{ `${option.name} ${option.tag}` }}</span>
        <span v-show="mouseIn || option.selected" class="text textButton" @click="handlePlay">{{ !isPlaying && isCurrentOptionPlay ?  '暂停' : '试听' }}</span>
    </div>
</template>

<script>
import { VoiceStatus, iconClassMap, iconMap } from '../config.ts'

export default {
  name: 'VoiceTypeOption',
  inject: ['mode'],

  props: {
    option: {
        type: Object,
        default: () => {}
    },
    isPlayingOptionId: {
        type: String,
        default: undefined
    },
    // audioSourceStatus主要用来区分音频文件播放时的状态，Unready下部展示，其他状态分别展示对应icon
    audioSourceStatus: {
        type: String,
        default: VoiceStatus.Unready
    },
  },

  data() {
    return {
        isPlaying: false,
        sourceUrl: '',
        iconClassMap,
        iconMap,
        VoiceStatus,
        screenWidth: window.innerWidth,
        mouseIn: false,
    }
  },

  computed: {
    isWidescreen() {
      return this.screenWidth === 2560;
    },
    isCurrentOptionPlay() {
        return this.isPlayingOptionId === this.option.id
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleResize);
    });
  },

  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    handleOptionClick() {
        this.$emit('handleSelect', this.option);
    },
    async handlePlay() {
        if(this.isCurrentOptionPlay) {
            this.isPlaying = !this.isPlaying;
        } else {
            this.isPlaying = false
        }

        this.$nextTick(() => {
            this.$emit('handlePlay', this.option, this.isPlaying);
        });
    },

    handleMouseOver() {
        this.mouseIn = true;
    },

    handleMouseOut() {
        this.mouseIn = false;
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.option {
    width: 220px;
    height: 48px;
    border-radius: 3px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px;
    border: 1px solid transparent;
    cursor: default;

    .voiceAvatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 8px;

        .overlay {
            display: block;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s ease;
            margin-right: 22px;

            i {
                display: block;
            }

            .icon {
                width: 14px;
                height: 14px;
                color: #FFFFFF;
            }
        }

        .residentOverlay {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 1;

            i {
                display: block;
            }
        }

        i {
            display: none;
        }
    }

    .voiceAvatar:hover .overlay {
        opacity: 1;
    }

    .text {
        line-height: 30px;
        font-size: 13px;
    }

    .textContent {
        display: block;
        width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .textActive {
        color: #ED7D0A;
        font-weight: bold;
    }

    .textButton {
        cursor: pointer;
        color: #ED7D0A;
        font-weight: bold;
        display: inline-block;
        margin-left: auto;
    }

    .audioArea {
        opacity: 0;
        width: 1px;
        height: 1px;
    }
}

.option:hover {
    background-color: #FCECDB;
}

.option-active {
    background-color: #f9dfc3;
    border: 1px solid #ED7700;
}

.option-margin {
    margin-left: 15px;
}

.h5 {
    .option {
        width: 230px;
        box-sizing: border-box;
    }
    .option:hover {
        background-color: #444444;
    }

    .option-active {
        background: #444444;
        border: 1px solid #666666;
    }
}

.rich {
    .option {
        width: 230px;
        .textButton {
            color: #3F9EFF;
        }

        .textActive {
            color: #3F9EFF
        }
    }
    .option:hover {
        background: rgba(64,158,255,0.20);
    }

    .option-active {
        background: rgba(64,158,255,0.20);
        border: 1px solid #409EFF;
    }
}
</style>
